module.exports = __webpack_public_path__ + "media/images/captive_portal/Today-ff95cca196feaee9d56d562a96cf95c7.svg";